'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LKIcon } from '../icon/module';
import {MenuComponent} from "./component";
import {MenuItemComponent} from "./menuitem/component";
import {KeyboardNavigation} from "../keyboardnavigation/module";

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon,
    KeyboardNavigation
  ],
  declarations: [MenuComponent, MenuItemComponent],
  exports     : [MenuComponent, MenuItemComponent]
})
export class LKMenu {
}
